import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

function useListCreditCardOffersQuery() {
  const $api = useApi();
  const lendingApplicationID = useLendingApplicationID();

  return $api.useQuery(
    "get",
    "/v2/lending/credit_card_offers/",
    {
      params: {
        query: {
          application: lendingApplicationID,
        },
      },
    },
    { enabled: Boolean(lendingApplicationID) }
  );
}

export { useListCreditCardOffersQuery };
